// Synthesized "treasure found" chime (Web Audio API) — no audio asset needed,
// so it can't 404 or bloat the bundle. A bright ascending arpeggio (classic
// game item-collect style) rather than a harsh buzzer tone. Browsers block
// audio playback until a user gesture on the page, so the AudioContext is
// created lazily and resumed on the first pointerdown/keydown; before that,
// playNotificationBuzzer() is a harmless no-op (the very first poll on a
// fresh page load won't have a "previous" unread count to compare against
// anyway — see callers).
let audioCtx = null;

const getAudioCtx = () => {
  if (!audioCtx) {
    const AudioContextCtor = window.AudioContext || window.webkitAudioContext;
    if (AudioContextCtor) audioCtx = new AudioContextCtor();
  }
  return audioCtx;
};

if (typeof window !== 'undefined') {
  const unlock = () => { getAudioCtx()?.resume(); };
  window.addEventListener('pointerdown', unlock, { once: true });
  window.addEventListener('keydown', unlock, { once: true });
}

// C5, E5, G5, C6 — major-triad-plus-octave arpeggio, the classic "treasure/coin" shape.
const TREASURE_NOTES  = [523.25, 659.25, 783.99, 1046.50];
const NOTE_DURATION   = 0.11;  // seconds per note
const NOTE_STEP       = NOTE_DURATION * 0.85; // slight overlap for a legato, sparkly feel
const REPEAT_COUNT    = 3;
const REPEAT_GAP      = 0.25;  // silence between repeats

const playArpeggio = (ctx, startTime) => {
  TREASURE_NOTES.forEach((freq, i) => {
    const noteStart = startTime + i * NOTE_STEP;
    const osc  = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'triangle';
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, noteStart);
    gain.gain.exponentialRampToValueAtTime(0.3, noteStart + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, noteStart + NOTE_DURATION);
    osc.connect(gain).connect(ctx.destination);
    osc.start(noteStart);
    osc.stop(noteStart + NOTE_DURATION + 0.02);
  });
};

export const playNotificationBuzzer = () => {
  const ctx = getAudioCtx();
  if (!ctx || ctx.state === 'suspended') return;

  const now = ctx.currentTime;
  const arpeggioDuration = TREASURE_NOTES.length * NOTE_STEP;
  for (let i = 0; i < REPEAT_COUNT; i++) {
    playArpeggio(ctx, now + i * (arpeggioDuration + REPEAT_GAP));
  }
};
